<template>
  <div>
    <!-- <BreadCrumbs
        :children="[
          {
            text: 'Reportes',
          },
        ]"
      /> -->

    <!-- FILTROS -->
    <div class="card ml-2 mr-2" id="filters">
      <div class="card-body">
        <div class="row">
          <div class="col-md-3 col-sm-12">
            <label for="date-to">Tipo de bonos</label>
            <select
              :disabled="loading"
              v-model="filters.type_giftcard"
              placeholder="Sucursal"
              class="form-control"
            >
              <option value="">-Seleccione-</option>
              <option value="Sin usar">Pendiente</option>
              <option value="Usado">Redimido</option>
              <!-- <option v-for="x in branchOffices" :key="x.id" :value="x.id">
                  {{ x.name }}
                </option> -->
            </select>
          </div>

          <div class="col-md-2 col-sm-12">
            <label for="date-to">Fecha desde</label>
            <input
              :disabled="loading"
              v-model="filters.from_date"
              type="date"
              placeholder="Fecha Desde"
              id="date-to"
              class="form-control"
            />
          </div>
          <div class="col-md-2 col-sm-12">
            <label for="date-to">Fecha hasta</label>
            <input
              :disabled="loading"
              v-model="filters.to_date"
              type="date"
              placeholder="Fecha hasta"
              id="date-to"
              class="form-control"
            />
          </div>
          <!-- <div class="col-md-3 col-sm-12">
              <label for="date-to">Tipo de pago</label>
              <select
                :disabled="loading"
                v-model="filters.paymentType"
                class="form-control"
              >
                <option value="">-Todos-</option>
                <option value="1">Transferencia</option>
                <option value="3">Tarjeta</option>
              </select>
            </div> -->
          <div class="col-md-2 col-sm-12">
            <button
              :disabled="loading"
              @click="getReport"
              class="btn btn-primary mt-4"
            >
              <span v-if="loading">Generando...</span>
              <span v-else><i class="fa fa-line-chart"></i> Generar</span>
            </button>
          </div>
          <div class="col-md-2 col-sm-12">
            <button @click="CleanFilter" class="btnClean btn mt-4">
              Limpiar
            </button>
          </div>
          <div
            class="col-md-10 col-12 totals-resume mt-3"
            style="display: flex"
            v-if="reportReady"
          >
            <table class="resume">
              <tr>
                <td class="w195"><b>Total de Bonos:</b></td>
                <td class="w50">{{ giftCards.length | number }}</td>
              </tr>
              <!-- <tr v-if="$store.getters.isAdmin">
                  <td class="w195"><b>Total envío (USD):</b></td>
                  <td class="w50">${{ shippingTotal | money }}</td>
                </tr>
                <tr v-if="$store.getters.isAdmin">
                  <td class="w195"><b>Total en cupones (USD):</b></td>
                  <td
                    :style="{ fontWeight: couponTotal > 0 ? 'bold' : 'normal' }"
                    :class="couponTotal > 0 ? 'w50 text-danger bold' : 'w50'"
                  >
                    ${{ couponTotal | money }}
                  </td>
                </tr> -->
              <tr>
                <td class="w195"><b>Total general (DOP):</b></td>
                <td class="w50">${{ giftCardTotalRD() | money }}</td>
              </tr>
              <tr>
                <td class="w195"><b>Total general (USD):</b></td>
                <td class="w50">${{ giftCardTotal() | money }}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- TABLA -->
    <div class="card ml-2 mr-2" v-if="reportReady">
      <div class="text-left pl-3 pt-1">
        <button class="btn main-bg" @click="exportToExcel()">
          <i class="fa fa-download"></i> Exportar
        </button>
      </div>
      <div class="card-body scrollable report">
        <div class="table-responsive">
          <table class="table">
            <thead class="thead-light">
              <tr>
                <th>Código</th>
                <th>Comercio</th>
                <th>Comprador</th>
                <th>Cantidad (USD)</th>
                <th>Cantidad (DOP)</th>
                <th>Recibe - Nombre</th>
                <th>Recibe - Cédula</th>
                <th>Recibe - Teléfono</th>

                <th>Estado</th>
                <th>Fecha de compra</th>
                <th v-if="filters.type_giftcard == 'Usado'">Fecha de uso</th>
                <th v-if="filters.type_giftcard == 'Usado'">Realizado por</th>
                <th v-if="filters.type_giftcard == 'Usado'">Tienda</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="x in giftCards" :key="x.id">
                <td>{{ x.Code }}</td>
                <td>{{ x.Company ? x.Company.Name : "" }}</td>
                <td>{{ x.User ? x.User.Name : "" }}</td>
                <td>{{ x.Amount }}</td>
                <td>{{ x.AmountDOP }}</td>
                <td>{{ x.ReceiverName }}</td>
                <td>{{ x.ReceiverReference }}</td>
                <td>{{ x.ReceiverPhone }}</td>

                <td>{{ x.Status }}</td>
                <td>{{ x.createdAt | formaDate }}</td>
                <td v-if="filters.type_giftcard == 'Usado'">
                  {{ x.UsedAt }}
                </td>
                <td v-if="filters.type_giftcard == 'Usado'">
                  {{ x.MadeBy }}
                </td>
                <td v-if="filters.type_giftcard == 'Usado'">
                  {{ x.Store }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="text-center" v-if="loading">
      <Loader />
    </div>
  </div>
</template>
<script>
import { UtilsService } from "../../services/UtilsService";
import BreadCrumbs from "../components/Breadcrumbs";
import DateHelper from "../../commons/DateHelper";
import Loader from "../components/Loader";
import { OrdersService } from "../../services/OrdersService";
import moment from "moment";
export default {
  name: "OrdersReport",
  components: { BreadCrumbs, Loader },
  filters: {
    formaDate(value) {
      if (value) {
        return moment(value).format("DD/MM/YYYY");
      }
    },
  },
  data: function () {
    return {
      orders: [],
      giftcards: [],
      giftCardsAll: [],

      loading: false,
      reportReady: false,
      filters: {
        from_date: "",
        to_date: "",
        type_giftcard: "",
      },
      rate: "",
      ordersService: new OrdersService(),
      utilsService: new UtilsService(),
    };
  },
  methods: {
    CleanFilter() {
      this.filters.from_date = "";
      this.filters.to_date = "";
      this.filters.type_giftcard = "";
    },
    shopWord(word, count) {
      if (!word) {
        return "";
      }
      if (word.length <= count) {
        return word;
      }
      return `${String(word).substring(0, count)}...`;
    },
    exportToExcel() {
      if (this.giftCards.length === 0) {
        return;
      }

      const data = [];
      this.giftCards.forEach((x) => {
        data.push([
          x.Code,
          x.Company ? x.Company.Name : "",
          x.User ? x.User.Name : "",
          x.Amount,
          x.AmountDOP,
          x.ReceiverName,
          x.ReceiverReference,
          x.ReceiverPhone,
          x.Note,
          x.Status,
          moment(x.createdAt).format("DD/MM/YYYY"),
          x.UsedAt || "",
          x.MadeBy || "",
          x.Store || "",
        ]);
      });
      const d = new Date();
      data.unshift([
        "CODIGO",
        "COMERCIO",
        "COMPRADOR",
        "CANTIDAD (USD)",
        "CANTIDAD (DOP)",
        "RECIBE - NOMBRE",
        "RECIBE - CEDULA",
        "RECIBE - TELEFONO",
        "NOTA",
        "ESTADO",
        "Fecha de compra",
        "Fecha de uso",
        "Realizado por",
        "Tienda",
      ]);
      this.$helpers.exportToCsv(
        `Reporte de bonos Domicanasta (${d}).csv`,
        data
      );
    },
    formaDate(value) {
      if (value) {
        console.log(value);
        return moment(value).format("YYYY-MM-DD");
      }
    },
    async get(timestampFrom, timestampTo) {
      this.loading = true;
      this.giftCards = [];
      try {
        const company = this.$store.getters.isAdmin
          ? null
          : this.$store.getters.getCompany;
        const res = await this.utilsService.getGiftCards(company);
        if (res.ok) {
          this.giftCardsAll = res.data;
          if (this.filters.from_date != "") {
            console.log(timestampFrom);
            this.giftCards = this.giftCardsAll.filter(
              (g) =>
                g.Status == this.filters.type_giftcard &&
                DateHelper.getTimestampFromDate(g.createdAt) >= timestampFrom &&
                DateHelper.getTimestampFromDate(g.createdAt) <= timestampTo
            );
          } else {
            this.giftCards = this.giftCardsAll.filter(
              (g) => g.Status == this.filters.type_giftcard
            );
          }

          this.reportReady = true;
        } else {
          this.$helpers.message("Error", res.message, "error");
        }
      } catch (error) {
        this.$helpers.message("Error", error.message, "error");
      }
      this.loading = false;
    },
    async getReport() {
      if (this.filters.type_giftcard === "") {
        this.$helpers.message(
          "Faltan campos",
          "El tipo es requerida",
          "warning"
        );
        return;
      }
      if (this.filters.from_date === "") {
        this.$helpers.message(
          "Faltan campos",
          "(Fecha desde) es requerida",
          "warning"
        );
        return;
      }
      if (this.filters.to_date === "") {
        this.$helpers.message(
          "Faltan campos",
          "(Fecha hasta) es requerida",
          "warning"
        );
        return;
      }
      const timestampFrom = DateHelper.getTimestampFromDate(
        this.filters.from_date
      );
      const timestampTo = DateHelper.getTimestampFromDate(this.filters.to_date);

      this.loading = true;
      this.reportReady = false;

      try {
        this.get(timestampFrom, timestampTo);
      } catch (error) {
        console.log("err ", error);
        this.$helpers.message("Error", "Algo salio mal", "error");
      }
      this.loading = false;
    },
    giftCardTotal() {
      return Number(
        this.giftCards.reduce((acc, cur) => acc + Number(cur.Amount), 0)
      ).toFixed(2);
    },
    giftCardTotalRD() {
      return Number(
        this.giftCards.reduce((acc, cur) => acc + Number(cur.AmountDOP), 0)
      ).toFixed(2);
    },
  },
};
</script>
<style scoped>
.btnClean {
  background-color: #1fc27f;
}
table {
  table-layout: fixed;
  font-weight: 400;
}
.report th,
td {
  font-weight: 400;
  min-width: 110px;
  max-width: 150px;
  overflow: hidden;
  word-wrap: break-word;
}
h4 {
  margin: 0;
}
.scrollable {
  max-height: 50vh;
  max-width: 100%;
  overflow: auto;
}
.totals-resume {
  font-size: 15px;
  color: black;
}
tfoot td {
  font-weight: bold;
}
.w195 {
  max-width: 195px !important;
  min-width: 160px !important;
}
.w50 {
  width: 70px !important;
  min-width: 70px !important;
}
.report-table th,
td {
  font-size: 13px;
}
.report-table thead th {
  font-weight: bold;
}
</style>
